export default "__VITE_ASSET__Dmmat0Xm__"